/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_ANNOUNCEMENT_URL, API_SUPPLIER_URL, COMMON_HEADER_CONFIG} from "../config";

class BrandService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListBrand = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/brands`,
        params: {
          per_page: 10,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getBrand = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/brand/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createBrand = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SUPPLIER_URL}/brand`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateBrand = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_SUPPLIER_URL}/brand/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.message);
          } else {
            reject(response.data.message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteBrand = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_SUPPLIER_URL}/brand/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListBrandType = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data`,
        params: {
          type: "brand-type",
          platform_key: "centralweb"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const brandService = new BrandService();

export default brandService;
